import React from 'react';
import {Paper} from 'material-ui';
import TemplateSubmit from './form/TemplateSubmit';
import classNames from 'classnames';

const PageBuilderWarning = ({
    isDirty,
    classes,
    saveButtonLabel,
    buttonClassName,
    loading,
    handleTemplateSave,
    handleTemplateDiscard,
    handleSetPreview
}) => {
    return (
        <div>
            {isDirty &&
            <Paper elevation={2} className={classNames(classes.warning, classes.marginBottom10)}>
                <TemplateSubmit
                    classes={classes}
                    saveButtonLabel={saveButtonLabel}
                    buttonClassName={buttonClassName}
                    loading={loading}
                    onSubmit={handleTemplateSave}
                    onDiscard={handleTemplateDiscard}
                    onSetPreview={handleSetPreview}
                />
            </Paper> }
        </div>
    );
};

export default PageBuilderWarning;


// WEBPACK FOOTER //
// ./src/containers/templates/builder/PageBuilderWarning.jsx